import moment from 'moment'
import { formatFilterForDisplay } from '@/utils/filters'
import {
    ATTRIBUTTE_TYPES,
} from '../Filters/FilterModal/filtersEntity'

const ChartTypes = {
    BAR: 'BAR',
    HEATMAP: 'HEATMAP',
    ATTRIBUTE: 'ATTRIBUTE',
    FREQUENCY_AND_DURATION: 'FREQUENCY_AND_DURATION',
    SCATTER: "SCATTER",
}

const ChartGroups = {
    ATTRIBUTE: "ATTRIBUTE",
    VARIANTS: "VARIANTS",
    ACTIVITIES: "ACTIVITIES",
    TRANSITIONS: "TRANSITIONS",
    OTHERS: "OTHERS",
}

const SortBy = {
    FREQUENCY: "FREQUENCY",
    DURATION_AVG: "DURATION_AVG",
    DURATION_MIN: "DURATION_MIN",
    DURATION_MAX: "DURATION_MAX",
    DURATION_STD: "DURATION_STD",
}

const SortDirection = {
    ASC: "ASCENDING",
    DESC: "DESCENDING",
}

const ATTRIBUTTE_TYPES_PRUEBA = {
    CATEGORICAL_ATTRIBUTE: ATTRIBUTTE_TYPES.CATEGORICAL_ATTRIBUTE(),
    BOOLEAN_ATTRIBUTE: ATTRIBUTTE_TYPES.BOOLEAN_ATTRIBUTE(),
    NUMERIC_ATTRIBUTE: ATTRIBUTTE_TYPES.NUMERIC_ATTRIBUTE(),
    DATETIME_ATTRIBUTE: ATTRIBUTTE_TYPES.DATETIME_ATTRIBUTE(),
    QUANTITY_ATTRIBUTE: ATTRIBUTTE_TYPES.QUANTITY_ATTRIBUTE(),
    OCCURRENCE_ATTRIBUTE: ATTRIBUTTE_TYPES.OCCURRENCE_ATTRIBUTE(),
}

const GRAFICAS = [
    {
        label: "Variants",
        key: "VARIANTS",
        content: [
            { key: "FREQUENCY", label: "Frequency" },
            { key: "DURATION_AVG", label: "Longer Average Duration" },
            { key: "DURATION_MAX", label: "Longer Maximum Duration" },
            { key: "DURATION_MIN", label: "Longer Minimum Duration" },
            { key: "DURATION_STD", label: "Longer Standard Deviation Time" },
            { key: "frequencyvsaverage", label: "Frequency vs average duration" },
        ],
    },
    {
        label: "Activities",
        key: "ACTIVITIES",
        content: [
            { key: "FREQUENCY", label: "Frequency" },
            { key: "DURATION_AVG", label: "Longer Average Duration" },
            { key: "DURATION_MAX", label: "Longer Maximum Duration" },
            { key: "DURATION_MIN", label: "Longer Minimum Duration" },
            { key: "DURATION_STD", label: "Longer Standard Deviation Time" },
        ],
    },
    {
        label: "Transitions",
        key: "TRANSITIONS",
        content: [
            { key: "FREQUENCY", label: "Frequency" },
            { key: "DURATION_AVG", label: "Longer Average Duration" },
            { key: "DURATION_MAX", label: "Longer Maximum Duration" },
            { key: "DURATION_MIN", label: "Longer Minimum Duration" },
            { key: "DURATION_STD", label: "Longer standard deviation time" },
        ],
    },
    {
        label: "Attribute",
        key: "ATTRIBUTE",
        content: [
            { key: "attributeInformation", label: "Attribute Information" },
        ],
    },
    {
        label: "Others",
        key: "OTHERS",
        content: [
            { key: "FREQUENCY_AND_DURATION", label: "Frequency and Duration" },
        ],
    },
]

const activityDateValue = [
    'ACTIVITY_ENDS_AFTER',
    'ACTIVITY_ENDS_BEFORE',
    'ACTIVITY_STARTS_AFTER',
    'ACTIVITY_STARTS_BEFORE',
]

const tracesDurationValue = [
    'TRACE_STARTS_BEFORE',
    'TRACE_ENDS_BEFORE',
    'TRACE_STARTS_AFTER',
    'TRACE_ENDS_AFTER',
]

function getLabel(group, type) {
    const findGroup = GRAFICAS.find((g) => g.key === group)
    const findType = findGroup.content.find((c) => c.key === type)
    return `${findGroup.label}: ${findType.label}`
}

function formatSelection(selection, allFilters, $t) {
    if (selection) {
        const rawId = selection.id
        const normalizedId = rawId?.id ? rawId.id : rawId
        const labelFilter = allFilters?.find((item) => item.id === normalizedId)

        // Prefer canonical formatter (same as Visualization) to keep labels/tooltips consistent.
        try {
            const canonical = {
                ...selection,
                id: normalizedId,
                ...(labelFilter?.kind && !selection.kind ? { kind: labelFilter.kind } : {}),
                ...(labelFilter?.label && !selection.label ? { label: labelFilter.label } : {}),
            }

            const display = formatFilterForDisplay(canonical, { t: $t })
            if (display && display.tooltip) {
                const unwrap = (maybe) => (maybe && typeof maybe === 'object' ? maybe.value : maybe)
                const activity = unwrap(selection.activity || selection?.meta?.activity)
                const arc = unwrap(selection.arc || selection?.meta?.arc)

                let tooltip = display.tooltip
                if (activity && !tooltip.includes(`${activity}`)) tooltip += ` | ${activity}`
                if (arc && !tooltip.includes(`${arc}`)) tooltip += ` | ${arc}`
                return tooltip
            }
        } catch (e) {
            // Fall back to legacy formatting below.
        }

        const { id, ...otherFields } = selection
        let formatted = ''
        if ((labelFilter?.kind === 'CATEGORICAL_ATTRIBUTE')
            || (labelFilter?.kind === 'BOOLEAN_ATTRIBUTE')
            || (labelFilter?.kind === 'DATETIME_ATTRIBUTE')
            || (labelFilter?.kind === 'NUMERIC_ATTRIBUTE')) {
            formatted += `${selection.attribute} `
            formatted += Object.values(ATTRIBUTTE_TYPES_PRUEBA).flat().find((item) => item.value === id).label
            formatted += ' '
            formatted += Array.isArray(selection?.values) ? selection.values.join(', ') : ''
            formatted += ' | '
            formatted += `${selection.activity} `
        } else if ((labelFilter?.id === 'TRACE_DURATION_GREATER_THAN')
                    || (labelFilter?.id === 'TRACE_DURATION_LESS_THAN')
                    || (labelFilter?.id === 'ARC_DURATION_GREATER_THAN')
                    || (labelFilter?.id === 'ARC_DURATION_LESSER_THAN')
                    || (labelFilter?.id === 'ACTIVITY_DURATION_GREATER_THAN')
                    || (labelFilter?.id === 'ACTIVITY_DURATION_LESS_THAN')) {
            formatted += $t(`visualization.filters.labels.${labelFilter.id}`)
            formatted += ': '
            formatted += moment.duration(selection.values).format("h[h] m[m] s[s]", { trim: "all" })
            if ((labelFilter?.id === 'ARC_DURATION_GREATER_THAN')
          || (labelFilter?.id === 'ARC_DURATION_LESSER_THAN')) {
                formatted += ' | '
                formatted += selection.arc
            }
            if ((labelFilter?.id === 'ACTIVITY_DURATION_GREATER_THAN')
          || (labelFilter?.id === 'ACTIVITY_DURATION_LESSER_THAN')) {
                formatted += ' | '
                formatted += selection.activity
            }
        } else if (labelFilter?.id === 'ACTIVITIES_DURATION_GREATER_THAN'
              || labelFilter?.id === 'ACTIVITIES_DURATION_LESS_THAN'
              || labelFilter?.id === 'ACTIVITIES_DURATION_LOOP_GREATER_THAN'
              || labelFilter?.id === 'ACTIVITIES_DURATION_LOOP_LESS_THAN'
        ) {
            const firstValue = (labelFilter?.id === 'ACTIVITIES_DURATION_GREATER_THAN' || labelFilter?.id === 'ACTIVITIES_DURATION_LESS_THAN')
                ? `${selection.values[0]}: ${selection.values[1]} `
                : `${selection.values[0]} `
            const secondValue = (labelFilter?.id === 'ACTIVITIES_DURATION_GREATER_THAN' || labelFilter?.id === 'ACTIVITIES_DURATION_LESS_THAN')
                ? `${selection.values[2]}: ${selection.values[3]}`
                : `${selection.values[1]}`
            formatted += $t(`visualization.filters.labels.${labelFilter?.id}`)
            formatted += ': '
            formatted += moment.duration(selection.values[selection.values.length - 1]).format("h[h] m[m] s[s]", { trim: "all" })
            formatted += ' | '
            formatted += firstValue
            formatted += secondValue
        } else if (tracesDurationValue.includes(labelFilter?.id)) {
            formatted += $t(`visualization.filters.labels.${labelFilter?.id}`)
            formatted += ': '
            const dateValue = Array.isArray(selection.values)
                ? selection.values[0]
                : selection.values

            if (moment(dateValue, moment.ISO_8601, true).isValid()) {
                formatted += moment(dateValue).format('DD/MM/YYYY HH:mm')
            } else {
                formatted += dateValue
            }
        } else if (activityDateValue.includes(labelFilter?.id)) {
            formatted += $t(`visualization.filters.labels.${labelFilter?.id}`)
            formatted += ': '

            if (selection.activity) {
                formatted += `${selection.activity} | `
            }

            if (selection.values?.length) {
                const firstValue = selection.values[0]
                if (moment(firstValue, moment.ISO_8601, true).isValid()) {
                    formatted += moment(firstValue).format('DD/MM/YYYY HH:mm')
                } else {
                    formatted += firstValue
                }
            }
        } else {
            formatted += $t(`visualization.filters.labels.${labelFilter?.id}`)
            formatted += ': '
            formatted += Object.entries(otherFields)
                .map(([, value]) => {
                    if (labelFilter?.kind === 'DATETIME' && value !== null) {
                        return moment(value).format('DD/MM/YYYY hh:mm A')
                    }
                    if (Array.isArray(value)) {
                        return value.join(', ')
                    }
                    return value?.label || value
                })
                .join(' ')
        }
        return formatted
    }
    return ''
}

export {
    ChartTypes, ChartGroups, SortBy, SortDirection, GRAFICAS, formatSelection, getLabel,
}
